import apiUserTienda from "../utils/apiUserTienda";

export const loginUserTienda = async (correo, password) => {
  try {
    const res = await apiUserTienda.post("/api/tienda/acceso/login", {
      correo,
      password,
    });

    const data = res.data;

    if (data?.token && data?.usuario?.id) {
      localStorage.setItem("tienda_token", data.token);
      localStorage.setItem("tienda_data", JSON.stringify(data.usuario));
      localStorage.setItem("tienda_usuario_id", String(data.usuario.id));
      localStorage.setItem(
        "tienda_permisos",
        JSON.stringify(data.permisos || [])
      );
      localStorage.setItem("tienda_id", String(data.usuario.tienda_id || ""));
    }

    return { ok: true, data };
  } catch (error) {
    const fromResponse = error?.response?.data;
    const fromInterceptor = error?.data;

    const payload =
      fromResponse !== undefined && fromResponse !== null
        ? fromResponse
        : fromInterceptor;

    let message =
      (typeof payload === "object" && payload?.message) ||
      (typeof payload === "string" ? payload : null);

    if (!message && error?.code === "ECONNABORTED") {
      message =
        "Tiempo de espera agotado. Comprueba que el backend esté en marcha y que la URL del API sea alcanzable desde el navegador.";
    }

    if (!message) {
      message = error?.message || "Error al conectar con el servidor";
    }

    return {
      ok: false,
      data:
        typeof payload === "object" && payload !== null
          ? { ...payload, message: payload.message || message }
          : { message },
    };
  }
};

export const meUsuarioTienda = async () => {
  const res = await apiUserTienda.get("/api/tienda/acceso/me");
  return res.data;
};

// Auto-edición del perfil del usuario logueado. Si la respuesta trae el
// usuario actualizado, refresca la sesión guardada en localStorage.
export const actualizarPerfilTienda = async (payload) => {
  const res = await apiUserTienda.put("/api/tienda/acceso/perfil", payload);
  const data = res.data;

  if (data?.usuario) {
    localStorage.setItem("tienda_data", JSON.stringify(data.usuario));
    if (data.usuario.id != null) {
      localStorage.setItem("tienda_usuario_id", String(data.usuario.id));
    }
    // Notifica al sidebar (escucha el evento "storage") en la misma pestaña.
    try {
      window.dispatchEvent(
        new StorageEvent("storage", {
          key: "tienda_data",
          newValue: JSON.stringify(data.usuario),
        })
      );
    } catch {
      // Algunos navegadores no permiten construir StorageEvent manualmente.
    }
  }

  return data;
};